import { Button } from '@cokitchen/cokitchen-components';
import React from 'react';
import { ReactComponent as EmptyStateIcon } from 'assets/icons/empty-event.svg';

const EmptyEventState = ({ hostEvent }: { hostEvent: () => void }) => {
  return (
    <div>
      <div className='flex justify-center my-48'>
        <div>
          <div className=''>
            <div className='flex justify-center'>
              <EmptyStateIcon />
            </div>
            <p className='my-2 text-lg  text-[#5E6164]'>{`You're yet to host any events`}</p>
          </div>
          <Button
            small
            color='primary'
            variant='block'
            className='mx-auto mt-8'
            onClick={hostEvent}>
            Host an event
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmptyEventState;
